export default (function (_ref) {
  var request = _ref.request;
  return {
    logisticHongdeMerchantEvalQuery: function logisticHongdeMerchantEvalQuery(data) {
      return request({
        url: '/logistics_hongde/merchantEval/query',
        method: 'get',
        params: data
      });
    },
    logisticHongdeMerchantEvalAdd: function logisticHongdeMerchantEvalAdd(data) {
      return request({
        url: '/logistics_hongde/merchantEval/addByAdmin',
        method: 'post',
        data: data
      });
    },
    logisticHongdeMerchantEvalDel: function logisticHongdeMerchantEvalDel(id) {
      return request({
        url: "/logistics_hongde/merchantEval/".concat(id),
        method: 'delete'
      });
    }
  };
});